import React, { Component } from 'react'
import { connect } from 'react-redux';
import AdministratorsApi from '../../api/administrators';
import { showMessage, showError, confirmAction } from '../../actions/uiActions';
import MenuItem from '@mui/material/MenuItem';
import KeyboardBackspace from '@mui/icons-material/KeyboardBackspace';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Checkbox from '@mui/material/Checkbox';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';

const reassignTypeTexts = {
    user: "Reassign Users",
    domain:"Update user assigned domains"
}

class AssignUser extends Component {

    state = {
        busy: false,
        selectedAdmin: '',
        expanded: false,
        allUsers: {},
        selectedDomains: [],
        selectedUserIds: [],
        expanded_domain: '',
        accountManagers: [],
        selectedAdminId: '',
        reassignType: "user",
        adminDomains: [],
        selectedUserDomains:[]
    }

    handleInputChange = e => {
        this.setState({ [e.target.name]: e.target.value });
    };

    async componentDidMount() {
        const administrators = await AdministratorsApi.getList();
        const accountManagers = administrators.filter(admin => admin.accountManager);
        this.setState({ accountManagers, adminDomains: this.props.account.domains || [] });
        this.getAdminAssignedUsers()
        
    }


    handleSubmit = async (e) => {
        e.preventDefault();
        if (this.state.reassignType === "user") {

            this.handleUserAssign()
        } else {
            this.handleDomainAssign()
        }
    }

    handleDomainAssign = async () => {
        try {
            this.setState({ busy: true })
            const payload = {
                domainIds: this.state.adminDomains,
                id: this.props.account._id
            }
            await AdministratorsApi.bulkAssignDomains(payload)
            this.props.onCreate()
            this.handleReset()
            this.setState({ busy: false })
        } catch (err) {
            this.setState({ busy: false })
            if (err.data.id) {
                const domain = this.props.domains.find(each => each.id === err.data.id)
                this.props.showError(`You need to assign a new admin to ${domain.name} before unchecking`)

            }
        }
    }

    handleUserAssign = async () => {
        if (this.state.selectedAdminId) {
            const isDomainPresent = this.validateSelectedDomains();
            if (!isDomainPresent) {
                this.props.confirmAction("You are about to reassign users to an admin who is not assigned to any of the checked user's domain(s). Do you wish to proceed?",
                    this.reassignUsers, "Reassign Users", "Proceed", "No", () => { })
            } else {
                this.reassignUsers()
            }
        } else {
            this.props.showError("You need to select account manager for the selected user(s)")
        }
    }

    reassignUsers = async () => {
        const { selectedUserIds, selectedAdminId } = this.state
        const { onClose, onCreate, showMessage, showError } = this.props

        const payload = { emails: selectedUserIds, accountManagerId: selectedAdminId }
        this.setState({ busy: true })

        try {
            const response = await AdministratorsApi.bulkAssignUsers(payload)
            if (response) {
                onCreate()
                showMessage("Account manager successfully assigned")
            }
        } catch (error) {
            onClose()
            showError(error)
        } finally {
            this.setState({
                selectedDomains: [],
                selectedUserIds: [],
                accountManagers: [],
                selectedAdmin: '',
                expanded_domain: '',
                selectedAdminId: '',
                busy: false
            })
        }
    }


    validateSelectedDomains = () => {
        const { selectedUserDomains , selectedAdminId} = this.state;
        const user = this.state.accountManagers.find(item => item._id === selectedAdminId)
        const domainIds = Array.from(new Set([...selectedUserDomains.map(each => each.domainId)]));
        return domainIds.every(item => (user.domains || []).includes(item));
    }

    handleSelection = (event) => {
        this.setState({ selectedAdmin: event.target.value })
    }

    getAdminAssignedUsers = async () => {
        const { account } = this.props
        this.setState({ busy: true })

        const users = await AdministratorsApi.getAdminAssignedUsers(account._id)
        if (users) {
            const allUsers = {};
            for (const user of users) {
                if (!allUsers[user.domain]) {
                    allUsers[user.domain] = { companyName: user.userDomain.company, users: [] }
                }
                allUsers[user.domain].users.push(user)
            }
            this.setState({ busy: false, allUsers })
        }
    }

    toggleExpansion = (expanded_domain) => {
        this.setState({ expanded: !this.state.expanded, expanded_domain });
    };

    handleSelectUserByDomain = (e, domainId, userIds) => {
        e.preventDefault();
        if (e.target.checked) {
            this.setState({
                selectedDomains: [...this.state.selectedDomains, domainId],
                selectedUserIds: Array.from(new Set([...this.state.selectedUserIds, ...userIds])),
                selectedUserDomains: [...this.state.selectedUserDomains, ...userIds.map(userId => ({userId, domainId})) ]
            });
        } else {
            this.setState({
                selectedDomains: this.state.selectedDomains.filter(name => name !== domainId),
                selectedUserIds: this.state.selectedUserIds.filter((f) => userIds.indexOf(f) < 0),
                selectedUserDomains: this.state.selectedUserDomains.filter(each => each.domainId !== domainId),
            });
        }
    }

    handleSelectUserById = (e, userId, domainId) => {
        e.preventDefault();
        if (e.target.checked) {
            this.setState({
                selectedUserIds: [...this.state.selectedUserIds, userId], 
                selectedUserDomains: [...this.state.selectedUserDomains, { userId, domainId }],
                
            });
        } else {
            this.setState({
                selectedUserIds: this.state.selectedUserIds.filter(id => id !== userId),
                selectedUserDomains: this.state.selectedUserDomains.filter(each => each.userId !== userId)
            });

        }
    }

    handleDomainChange = (domainId) => {
        if (this.state.adminDomains.includes(domainId)) {
            this.setState({
                adminDomains: this.state.adminDomains.filter(each => each !== domainId)
            })
        } else {
            this.setState({
                adminDomains: [...this.state.adminDomains, domainId]
            })
        }

    }

    handleButtonDisable = () => {
        if (this.state.reassignType === "user") {
            return !this.state.selectedUserIds.length
        } else {
            const { domains } = this.props.account
            const { adminDomains } = this.state
            return (domains || []).every(item => adminDomains.includes(item)) && adminDomains.every(item => (domains || []).includes(item));
        }
    }

    handleReset = () => {
        this.setState({
            selectedUserIds: [],
            selectedAdminId: "",
            adminDomains: this.props.account.domains || []
        })
    }
    render() {
        const { expanded, expanded_domain, busy, accountManagers, selectedAdminId, allUsers, selectedDomains, selectedUserIds, reassignType, adminDomains } = this.state
        const { onClose } = this.props
        const keyArray = Object.keys(allUsers);
        return (
            <section className="animated fadeIn">
                <header>
                    <h1>{`Manage Administrators > Ressaign user/domain`}
                        <button onClick={onClose} className="close">
                            <KeyboardBackspace /> Back
                        </button>
                    </h1>
                </header>

                <div className="row">
                    <div className="col-12">
                        <div className='row'>

                            <div className={`col-xl-6 col-4 ${reassignType === "domain" && "offset-md-3"}`}>
                                <h5>{reassignTypeTexts[reassignType]}</h5>
                                <div className="line-break"></div>
                                <div className="info-block mb-2">
                                    <FormControl className="full-width font-normal">
                                        <Select
                                            value={reassignType}
                                            onChange={e => {
                                                this.setState({ reassignType: e.target.value })
                                                this.handleReset()
                                            }
                                            }
                                        >
                                            <MenuItem value="user">Checked users</MenuItem>
                                            <MenuItem value="domain">Domains</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>
                            {reassignType === "user" && <div className="col-xl-6 col-4">
                                <h5>To</h5>
                                <div className="line-break"></div>
                                <div className="info-block mb-2">
                                    <FormControl className="full-width font-normal">
                                        <Select
                                            value={selectedAdminId}
                                            onChange={e =>
                                                this.setState({ selectedAdminId: e.target.value })
                                            }
                                            inputProps={{
                                                name: 'selectedAdminId',
                                                id: 'selectedAdminId'
                                            }}
                                        >
                                            <MenuItem value="">Select...</MenuItem>
                                            {accountManagers.map((manager, index) => (
                                                <MenuItem key={`manager-${index}`} value={manager._id}>
                                                    {manager.name}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </div>
                            </div>}
                        </div>
                        <div className="line-break"></div>
                        <div className="form-group text-center mt-5 mb-5">
                            <button
                                className="btn loadin btn-primary"
                                onClick={this.handleSubmit}
                                disabled={busy || this.handleButtonDisable() }
                            >
                                Save Changes
                            </button>
                        </div>
                        {reassignType === "user" && <>
                            {keyArray.length ?
                                <Paper>
                                    <Table>
                                        {keyArray.map((domainId, index) => {
                                            const users = allUsers[domainId].users
                                            return (
                                                <div key={index}>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell className="width10pct">
                                                                <Checkbox
                                                                    checked={selectedDomains.includes(domainId)}
                                                                    onChange={e => this.handleSelectUserByDomain(e, domainId, users.map((user) => user.email))}
                                                                    value={domainId}
                                                                />
                                                                Company Name: {allUsers[domainId].companyName}
                                                            </TableCell>
                                                            <TableCell>

                                                            </TableCell>
                                                            <TableCell className="width10pct">
                                                                Total User: {users.length}
                                                            </TableCell>
                                                            <TableCell onClick={() => this.toggleExpansion(domainId)} className="width15pct text-centers">
                                                                <NavigateNextIcon className={`navigate-next ${expanded && expanded_domain === domainId ? "opened" : ""}`} />
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableHead>
                                                    {
                                                        <Table>
                                                            {expanded && expanded_domain === domainId && (
                                                                <TableBody>
                                                                    {users.map((user, indexUser) => (
                                                                        <TableRow key={indexUser}>
                                                                            <TableCell>
                                                                                <Checkbox
                                                                                    checked={selectedUserIds.includes(user.email)}
                                                                                    onChange={e => this.handleSelectUserById(e, user.email, domainId)}
                                                                                    value={user.email}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell>{user.firstname} {user.lastname}</TableCell>
                                                                            <TableCell>{user.email}</TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell></TableCell>
                                                                            <TableCell></TableCell>
                                                                        </TableRow>
                                                                    ))}
                                                                </TableBody>
                                                            )}
                                                        </Table>
                                                    }
                                                </div>

                                            )
                                        })}
                                    </Table>
                                </Paper>
                                :
                                <p className="text-center mt-xl-5">No user is currently assigned to this admin</p>
                            }
                        </>
                        }

                        {reassignType === "domain" && (
                            <>
                                {!this.state.adminDomains.length && <><p>* You have no domain assigned to you</p>
                                    <p>* Click on a domain and the save changes button to assign a domain</p></>}
                                <Paper>
                                    <Table>
                                        {this.props.domains.map((domain) => (
                                            <div key={domain.id}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className="width10pct">
                                                            <Checkbox
                                                                checked={this.state.adminDomains.includes(domain.id)}
                                                                onChange={() => this.handleDomainChange(domain.id)}
                                                                value={domain.id}
                                                            />
                                                            Company Name: {domain.name}
                                                        </TableCell>
                                                        <TableCell>

                                                        </TableCell>
                                                    </TableRow>
                                                </TableHead>
                                            </div>

                                        )
                                    )}
                                    </Table>
                                </Paper>
                            </>

                        )}
                    </div>


                </div>
            </section>
        )
    }
}

const mapStateToProps = state => {
    return state;
};
export default connect(mapStateToProps, {
    showMessage,
    showError,
    confirmAction
})(AssignUser);
